export function PageTitle({ title = "", children }) {
  return (
    <div className={`bg-white ${!children ? "hidden md:block" : ""}`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="sm:text-center lg:text-left">
          {title.length > 0 && (
            <h1 className="hidden text-3xl font-semibold tracking-tighter text-gray-900 sm:text-4xl md:block lg:text-5xl">
              {title}
            </h1>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
